module.exports = __webpack_public_path__ + "img/HA1505-76.d76c00a6.jpg";